import React from 'react';
import { Link } from 'react-router-dom';

// "Highlighted suggestions" - one weighted-random pick per category (game/music/screen/manga),
// persisted server-side as PeriodSuggestion rows so the pick is stable across page loads.
// Note: Book media is folded into the 'manga' category server-side (see CATEGORY_TYPES in
// weekly_summary_service.py) rather than split into its own bucket - nothing to change here
// since categories are entirely API-driven.
const PeriodSuggestions = ({ suggestions, period }) => {
  if (!suggestions || suggestions.length === 0) {
    return null;
  }

  const periodNoun = period?.kind === 'monthly' ? 'Month' : period?.kind === 'yearly' ? 'Year' : 'Week';
  const heading = `This ${periodNoun}'s Chosen Picks`;

  return (
    <section className="period-summary-section period-summary-suggestions">
      <h2>{heading}</h2>
      <div className="period-summary-suggestions-grid">
        {suggestions.map(s => (
          <Link to={`/media-item/${s.media_id}`} className="period-summary-suggestion-card" key={s.media_id}>
            <div className="period-summary-suggestion-image">
              <img src={s.image} alt={s.title} />
              <span className="period-summary-suggestion-category">
                <img src={s.category_icon} alt="" className="icon" />
                {s.category_label}
              </span>
            </div>
            <div className="period-summary-suggestion-info">
              <h3>{s.title}</h3>
              {s.score != null && (
                <div className="period-summary-suggestion-score">
                  <img src="/static/icons/star-solid.svg" alt="Score" className="icon" />
                  <span>{s.score}</span>
                </div>
              )}
              <p>{s.description || 'No description available.'}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default PeriodSuggestions;
